import { OverviewState, useOverviewLinkState } from '../linkstate/fleetOverview.linkstate';

export const useOverviewLinkStateActions = () => {
    const [state, setState] = useOverviewLinkState();
    return {
        patch: (patch: Partial<OverviewState>) => setState({ ...state, ...patch }),
    };
};
